import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setGroups,
  getFilter,
  getProducts,
} from "../../store/reducers/filterSlice";

class Groups extends React.Component {
  state = {
    closed: [],
  };

  constructor(props) {
    super(props);
    this.toggle = (id) => {
      let closed = this.state.closed;

      var index = closed.indexOf(id);

      if (index === -1) {
        closed.push(id);
      } else {
        closed.splice(index, 1);
      }

      this.setState({
        closed: closed,
      });
    };
    this.isOpened = (id) => {
      let closed = this.state.closed;

      var index = closed.indexOf(id);

      return index < 0;
    };
  }
  changeValue(value) {
    this.props.setGroupsAndFilter(value);
  }
  isSelected(value) {
    return (
      this.props.selected.includes("" + value) ||
      this.props.selected.includes(parseInt(value))
    );
  }
  render() {
    return (
      <>
        {this.props.groups.map((group, i) => (
          <li data-filter-part="item-container" key={i}>
            <span
              className={`radio-container ${
                this.isOpened(group.id) ? " selected" : ""
              } ${group.subgroups.length < 1 ? "empty" : ""}`}
              onClick={() => {
                this.toggle(group.id);
              }}
            >
              <input
                type="radio"
                checked={this.isSelected(group.id)}
                name="groups[]"
                onChange={(e) => {
                  this.changeValue(e.target.value);
                }}
                id={"filter-checkbox-mg-" + group.id}
                value={group.id}
              />
              <label
                className="radio-label"
                htmlFor={"filter-checkbox-mg-" + group.id}
              >
                {group.value}
              </label>
            </span>
            <ul
              className={`l2 ${this.isOpened(group.id) ? " selected" : ""}`}
              data-filter-part="item-children-container"
            >
              {group.subgroups.map((subgroup, i) => (
                <li key={i}>
                  <input
                    type="checkbox"
                    checked={this.isSelected(subgroup.id)}
                    name="groups[]"
                    id={"filter-checkbox-sg" + subgroup.id + "-" + group.id}
                    onChange={(e) => {
                      this.changeValue(e.target.value);
                    }}
                    value={subgroup.id}
                  />
                  <label
                    htmlFor={
                      "filter-checkbox-sg" + subgroup.id + "-" + group.id
                    }
                  >
                    {subgroup.value}
                  </label>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    selected: state.filter.request.groups,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setGroupsAndFilter: (args) => (dispatch) => {
        dispatch(setGroups(args));
        dispatch(getFilter());
        dispatch(getProducts());
      },
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
